"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const MultiPlayerPage_1 = require("../MultiPlayerPage");
const Button_1 = __importDefault(require("./Button"));
const TextInput_1 = __importDefault(require("./TextInput"));
const MultiPlayerGuestForm = ({ onGameStart }) => {
    const classes = (0, MultiPlayerPage_1.useStyles)();
    const [state, setState] = (0, react_1.useState)({ nickname: "", code: "" });
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const handleChange = (event) => {
        const { value, name } = event.target;
        setState(Object.assign(Object.assign({}, state), { [name]: value }));
    };
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        setIsLoading(true);
        setError(null);
        const result = (yield fetch(`/api/game-exists/?code=${state.code}`).then((res) => res.json()));
        setIsLoading(false);
        console.log("result", result);
        if (result.gameExists) {
            onGameStart({ code: state.code, nickname: state.nickname, player: "P2" });
        }
        else
            setError(`The room "${state.code}" does not exist.`);
    });
    return (react_1.default.createElement("form", { className: classes.form, onSubmit: handleSubmit },
        react_1.default.createElement(TextInput_1.default, { className: classes.input, name: "nickname", value: state.nickname, label: "Nickname", error: null, onChange: handleChange, placeholder: "John Doe", required: true }),
        react_1.default.createElement(TextInput_1.default, { className: classes.input, value: state.code, name: "code", label: "Code", error: error, onChange: handleChange, placeholder: "1234", required: true }),
        react_1.default.createElement(Button_1.default, { disabled: isLoading, className: classes.button }, "Connect")));
};
exports.default = MultiPlayerGuestForm;
